import service from '@/services/inventario/merma'

const getDefaultState = () => ({
  merma: { tipo: '', causa: '', cuentaContable: '' },

  mermaDefault: [
    {
      tipo: 'Merma (planificada)',
      causa: ['Residuos', 'Manipulación', 'Pérdida Natural', 'Muestra Gratis', 'Donación', 'Viaticos', 'Regalias', 'Empleados', 'Otro']
    },
    {
      tipo: 'Desperdicio',
      causa: ['Error Humano', 'Robo Externo', 'Robo Interno', 'Contaminación', 'Faltante', 'Mal Estado', 'Avería', 'Devoluciones', 'Otro']
    }
  ],

  lista: [], // lista de tipos de merma (gestion Merma)
  listaMerma: [], // lista de mermas manuales registradas
  currentRow: null,
  currentRowControl: null,

  controlMerma: [],
  controlMermaPageInfo: {},

  saved: 'null'
})

export const state = () => getDefaultState()

export const mutations = {
  RESET_STATE: state => Object.assign(state, getDefaultState()),
  RESET: state => (state.merma = { ...getDefaultState().merma }),
  SET_ROW: (state, row) => (state.currentRow = row),
  SET_ROW_CONTROL: (state, row) => (state.currentRowControl = row),
  SET: (state, obj) => {
    const causa = obj.causa.join('\n')
    state.merma = { ...obj, causa }
    state.saved = true
  },
  SET_LIST: (state, obj) => {
    state.lista = obj //[...new Set([...state.lista.map(JSON.stringify), ...obj.map(JSON.stringify)])].map(JSON.parse)
  },
  UPDATE_LIST: (state, obj) => {
    const nObj = state.lista.find(e => e._id === obj._id)
    if (!nObj) state.lista = [obj, ...state.lista]
    else Object.keys(nObj).forEach(i => (nObj[i] = obj[i]))

    state.saved = true
  },
  DELETE_LIST: (state, { obj }) => {
    state.lista = state.lista.filter(e => e._id !== obj._id)
  },
  SAVE_CHANGES: (state, obj) => {
    state.merma = obj
    state.saved = false
  },
  SET_CONTROL_MERMA: (state, obj) => {
    state.controlMerma = [...new Set([...state.controlMerma.map(JSON.stringify), ...obj.feed.map(JSON.stringify)])].map(JSON.parse)

    state.controlMermaPageInfo = obj.pageInfo
  },
  SET_CONTROL_MERMA_BY_DATE: (state, obj) => {
    state.controlMerma = obj.feed
    state.controlMermaPageInfo = obj.pageInfo
  },
  UPDATE_CONTROL_MERMA_LIST: (state, obj) => {
    const nObj = state.controlMerma.find(e => e._id === obj._id)

    if (!nObj) state.controlMerma = [obj, ...state.controlMerma]
    else Object.keys(nObj).forEach(i => (nObj[i] = obj[i]))
  }
}

export const actions = {
  create: async ({ commit, rootGetters }, input) => {
    // delete input.createdAt
    // delete input.updatedAt

    const accountingModule = rootGetters['facturacion/emisorStore/getAccountingModule']
    if (!accountingModule) delete input.cuentaContable

    return service
      .create({
        ...input,
        emisor: {
          _id: await rootGetters['facturacion/emisorStore/get_Id']
        }
      })
      .then(result => {
        commit('UPDATE_LIST', {
          ...input,
          _id: result._id
        })

        return result
      })
  },
  mermaSalida: async ({ commit, rootGetters }, input) => {
    const accountingModule = rootGetters['facturacion/emisorStore/getAccountingModule']

    return service
      .mermaSalida(
        {
          ...input,
          cantidad: Number(input.cantidad),
          emisor: {
            _id: await rootGetters['facturacion/emisorStore/get_Id']
          }
        },
        accountingModule
      )
      .then(result => {
        commit('UPDATE_CONTROL_MERMA_LIST', {
          ...input,
          _id: result._id
        })

        return result
      })
  },
  readById: async ({ commit }, input) => commit('SET', input),
  resetList: ({ state }) => (state.listaa = []),
  readAllByEmisor: async ({ commit, state, dispatch, rootGetters }, force = false) => {
    if (state.lista.length && !force) return state.lista

    state.lista = []

    const accountingModule = rootGetters['facturacion/emisorStore/getAccountingModule']

    if (accountingModule) {
      await dispatch('contabilidad/accountStore/readAllByEmisor', { restart: false }, { root: true }).catch(() => {})
    }

    return service.readAllByEmisor(rootGetters['facturacion/emisorStore/get_Id']).then(result => {
      // si es una nueva lista, asigna los valores por defecto y los guarda.
      if (!result.length) {
        // busca la cuenta contable default
        if (accountingModule) {
          const cuenta = rootGetters['contabilidad/accountStore/getAccountByType']('Costos de inventario')

          if (cuenta.length) {
            const defaultAccount = cuenta?.find(account => account.sysName === 'Ajuste de inventario por merma')

            state.mermaDefault.forEach(item => {
              item.cuentaContable = defaultAccount?._id
            })
          }
        }
        state.mermaDefault.forEach(item => dispatch('create', item))
      } else commit('SET_LIST', result)

      return true
    })
  },
  delete: ({ commit }, { items }) =>
    service.delete(items).then(result => {
      result.forEach(i => {
        if (i.state) commit('DELETE_LIST', { obj: i })
      })
      return result
    }),

  resetControlMerma: ({ state }) => {
    state.controlMerma = []
    state.controlMermaPageInfo = {}
  },

  readAllControlMerma: async ({ commit, state, dispatch, rootGetters }, { restart = false, limit = 10, filter }) => {
    if (restart) await dispatch('resetControlMerma')

    const accouting = rootGetters['facturacion/emisorStore/getAccountingModule']

    return service
      .readAllControlMerma(state.controlMermaPageInfo.nextPageCursor, limit, await rootGetters['facturacion/emisorStore/get_Id'], filter, accouting)
      .then(result => {
        commit('SET_CONTROL_MERMA', result)
        return true
      })
  },

  readAllControlMermaByDateRange: async ({ commit, dispatch, rootGetters }, { inicio, final, filter }) => {
    await dispatch('resetControlMerma')

    const accouting = rootGetters['facturacion/emisorStore/getAccountingModule']

    return service.readAllControlMermaByDateRange(rootGetters['facturacion/emisorStore/get_Id'], inicio, final, filter, accouting).then(result => {
      return commit('SET_CONTROL_MERMA_BY_DATE', result)
    })
  },

  saveChanges: ({ commit }, input) => commit('SAVE_CHANGES', input)
}

// export const getters = {
//   get: state => merma => {
//     return state.listaa.find(e => e._id === merma._id)
//   }
// }
